import style from "./Term.module.scss";
import { Button, Input } from "@ui";
import { useEffect, useState } from "react";
import { useAppSelector } from "store/hooks";
import { useUpdateUsersRentTimeMutation } from "@RTKQuery/admin/customers/customers";

export function Term() {
    const { applytTo, selectRows } = useAppSelector(state => state.customersAdminPage)

    const [updateUsersRentTime, { isSuccess, isLoading, reset, error }] = useUpdateUsersRentTimeMutation();

    const [inputDay, setInputDay] = useState<string>("")
    const [inputHours, setInputHours] = useState<string>("")

    useEffect(() => {
        let timer: NodeJS.Timeout;

        if (isSuccess) { 
            setInputDay("")
            setInputHours("")
            timer = setTimeout(() => {
                reset();
            }, 2500)
        }

        return () => {
            clearTimeout(timer)
        }
    }, [isSuccess])

    return (
        <div className={style.container}>
            <p className="text-center text-[#1B1B1D] text-[16px] font-semibold leading-normal mb-[10px]">Додати термін використання</p>
            <Input
                value={inputDay}
                onChange={(value) => {
                    setInputDay(value.replace(/\D/g, ""))
                }}
                label="Дні:"
                customStyle={{
                    width: "!w-[300px] !max-w-[300px] !mx-auto !mb-[10px]"
                }}
            />
            <Input
                value={inputHours}
                onChange={(value) => {
                    setInputHours(value.replace(/\D/g, ""))
                }}
                label="Години:"
                customStyle={{
                    width: "!w-[300px] !max-w-[300px] !mx-auto !mb-[30px]"
                }}
            />
            <Button
                tabIndex={-1}
                text={
                    isSuccess
                        ? "Успішно збережено"
                        : "Зберегти"
                }
                color="blue"
                customStyle={{
                    button: "!w-[180px] !h-[38px] ",
                    width: "!mx-auto"
                }}
                loading={isLoading}
                errors={[
                    (error && ((extractError) => {
                        return extractError(error)
                    }))
                ]}
                onClick={() => {
                    if (inputDay || inputHours) {
                        updateUsersRentTime({
                            days: Number(inputDay),
                            hours: Number(inputHours),
                            user_ids: (applytTo === "selected") ? selectRows : undefined,
                            is_active: (applytTo === "active") ? true : (applytTo === "notActive") ? false : undefined 
                        })
                    }
                }}
                resetStatus={() => {
                    reset();
                }}
            />
        </div>
    )
}